import { FilterInfoRow } from "@faire/deprecated-retailer-visitor-shared/components/Filters/FilterInfoRow";
import { FilterName } from "@faire/deprecated-retailer-visitor-shared/components/Filters/FilterName";
import { FaireHelmet } from "@faire/deprecated-retailer-visitor-shared/components/Helmet/index";
import { useSearchPageShouldShowHeaderHelmet } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageHeaderHelmet/__internal__/useSearchPageShouldShowHeaderHelmet";
import { useSearchPageFormattedTotalPrimaryResultsCount } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Filters/useSearchPageFormattedTotalPrimaryResultsCount";
import { useSearchPageQueryIsLoading } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryIsLoading";
import { useIsLoggedOutDiscoverPage } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useIsLoggedOutDiscoverPage";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { headerStyles } from "@faire/deprecated-retailer-visitor-shared/views/search/__internal__/SearchProductsPage/__internal__/SearchStyles";
import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { ResponsiveContentV2 } from "@faire/web/ui/ResponsiveContentV2";
import React from "react";
import styled from "styled-components";

export const SearchPageHeaderHelmet = ({
  helmetData,
  filterRef,
}: {
  helmetData: { title: string; description: string; header: string };
  filterRef?: React.RefObject<HTMLDivElement | null>;
}) => {
  const loading = useSearchPageQueryIsLoading();
  const totalPrimaryResultsFormatted =
    useSearchPageFormattedTotalPrimaryResultsCount();
  const shouldShowHeaderHelmet = useSearchPageShouldShowHeaderHelmet();
  const isLoggedOutDiscover = useIsLoggedOutDiscoverPage();

  if (!shouldShowHeaderHelmet) {
    return null;
  }
  if (isLoggedOutDiscover) {
    return <FaireHelmet title={helmetData.title} />;
  } else {
    // logged-out search page
    return (
      <ResultInfoRow>
        <FaireHelmet
          title={helmetData.title}
          description={helmetData.description}
        />
        {/* only show header on logged-out search tablet and above */}
        <ResponsiveContentV2
          tabletAndAbove={
            <>
              <Header data-test-id="helmet-data-header">
                {helmetData.header}
              </Header>
              <Column>
                <StyledFilterInfoRow
                  name={FilterName.SEARCH}
                  resultsCount={totalPrimaryResultsFormatted}
                  isLoading={loading}
                  divRef={filterRef}
                />
              </Column>
            </>
          }
        />
      </ResultInfoRow>
    );
  }
};

// For SEO purpose, we need using h1 tag for the header
const Header = styled(Typography).attrs({
  variant: {
    mobileAndAbove: "pageHeaderSerifRegular",
    tabletAndAbove: "displaySSerifRegular",
  },
  forwardedAs: "h1",
})`
  ${headerStyles}
`;

const StyledFilterInfoRow = styled(FilterInfoRow)`
  ${responsiveMediaQueries.tabletAndBelow} {
    margin-right: ${getSpacing("2x")};
  }
`;

const ResultInfoRow = styled(Row).attrs({ align: "baseline" })`
  padding-top: ${getSpacing("2x")};
`;
